(function () {
  'use strict';

  angular
      .module('tfc.retailer.StandardReports')
      .factory('recipientProfiles', recipientProfiles)
      .controller('KidsProfilesCtrl', KidsProfilesCtrl)
      .controller('SFOProfilesCtrl', SFOProfilesCtrl);


  // @ngInject
  function KidsProfilesCtrl(storeKeys, filters, StandardReports, ShopperReports, SectionConfig, Callout, CalloutLabelService, UserCohort, recipientProfiles) {

    var vm = this;

    var topProfilesCallout = Callout.topMainSubLabelConfig(
        SectionConfig.allTimeKidsProfiles,
        SectionConfig.allTimeKidsProfiles.callout.values[0].values[0],
        [
          SectionConfig.allTimeKidsProfiles.callout.values[0].values[1],
          SectionConfig.allTimeKidsProfiles.callout.values[0].values[2]
        ],
        recipientProfiles.fetchAllTimeData('daily-users-kids', storeKeys, filters, 'newRecipientCount')
    );

    var topShoppersCallout = Callout.topMainSubLabelConfig(
        SectionConfig.allTimeUserWithKidsProfiles,
        SectionConfig.allTimeUserWithKidsProfiles.callout.values[0].values[0],
        [
          SectionConfig.allTimeUserWithKidsProfiles.callout.values[0].values[1],
          SectionConfig.allTimeUserWithKidsProfiles.callout.values[0].values[2]
        ],
        recipientProfiles.fetchAllTimeData('daily-users-kids', storeKeys, filters, 'activeShopperCount')
    );


    recipientProfiles.setPropertiesInVM(
        storeKeys,
        filters,
        [
        {
          section : SectionConfig.newKidsProfiles ,
          formatFunc: StandardReports.transformIntoChartData('newRecipientCount')
        },
        {
          section : SectionConfig.tfUsersWithNewKids,
          formatFunc: StandardReports.transformIntoChartData('activeShopperCount')
        },
        {
          section : SectionConfig.kidsMauTF
        },
        {
          section : SectionConfig.kidsDauTF,
          formatFunc: StandardReports.transformIntoChartData('activeShopperCount')
        }
        ],
        [ topProfilesCallout, topShoppersCallout], vm);
  }

  // @ngInject
  function SFOProfilesCtrl(storeKeys, filters, StandardReports, ShopperReports, SectionConfig, Callout, CalloutLabelService, UserCohort, recipientProfiles) {
    var vm = this;

    var topProfilesCallout = Callout.topMainSubLabelConfig(
        SectionConfig.allTimeSFOProfiles,
        SectionConfig.allTimeSFOProfiles.callout.values[0].values[0],
        [
          SectionConfig.allTimeSFOProfiles.callout.values[0].values[1],
          SectionConfig.allTimeSFOProfiles.callout.values[0].values[2]
        ],
        recipientProfiles.fetchAllTimeData('daily-users-sfo', storeKeys, filters, 'newRecipientCount')
    );

    var topShoppersCallout = Callout.topMainSubLabelConfig(
        SectionConfig.allTimeUserWithSFOProfiles,
        SectionConfig.allTimeUserWithSFOProfiles.callout.values[0].values[0],
        [
          SectionConfig.allTimeUserWithSFOProfiles.callout.values[0].values[1],
          SectionConfig.allTimeUserWithSFOProfiles.callout.values[0].values[2]
        ],
        recipientProfiles.fetchAllTimeData('daily-users-sfo', storeKeys, filters, 'activeShopperCount')
    );

    recipientProfiles.setPropertiesInVM(
        storeKeys,
        filters,
        [
        {
          section : SectionConfig.newSFOProfiles ,
          formatFunc: StandardReports.transformIntoChartData('newRecipientCount')
        },
        {
          section : SectionConfig.tfUsersWithNewSFO ,
          formatFunc: StandardReports.transformIntoChartData('activeShopperCount')
        },
        {
          section : SectionConfig.sfoMauTF
        },
        {
          section : SectionConfig.sfoDauTF,
          formatFunc: StandardReports.transformIntoChartData('activeShopperCount')
        }
        ],
        [ topProfilesCallout, topShoppersCallout], vm);
  }

  // @ngInject
  function recipientProfiles(StandardReports, ShopperReports, ConsumerChartDisplay, Callout){


    return {
      setPropertiesInVM: setPropertiesInVM,
      chartDataFunc: chartDataFunc,
      fetchAllTimeData: fetchAllTimeData
    };

    function setPropertiesInVM(storeKeys, filters, chartSectionDetails, topCalloutSections, vm){
      var detailLevel = filters.pathParams.detailLevel;

      vm.dateRange = {startDate: filters.queryParams.startDate, endDate: filters.queryParams.endDate};

      vm.transactionColorSwatch = StandardReports.getColorSwatches([
        ConsumerChartDisplay.Colors.registered.stroke,
        ConsumerChartDisplay.Colors.travellingRegistered.stroke,
        ConsumerChartDisplay.Colors.siteRegistered.stroke
      ]);

      var queryFilters = _.merge(filters.queryParams, {storeKey: storeKeys});
      vm.apiParams = { detailLevel: detailLevel, queryParams: queryFilters };

      vm.topSections = _.map(topCalloutSections,'section');

      topCalloutSections.forEach(function (sectionDetail) {
        vm[sectionDetail.section.name] = sectionDetail;
      });

      chartSectionDetails.forEach(function (sectionDetail) {

        var section = sectionDetail.section;
        var sectionName = section.name;
        var formatFunc = sectionDetail.formatFunc;
        var sectionChartData = sectionName + "ChartData";
        var sectionTemplate = sectionName + "Section";

        vm[sectionTemplate] = Callout.labelValueConfig(section);
        vm[sectionChartData] = function (rawData) {
          return {
            dateMetrics: formatFunc ? formatFunc(rawData).dateMetrics : rawData.dateMetrics,
            summary: rawData.summary
          }
        }

      });
    }


    // Todo - Need to make this better
    function chartDataFunc(summaryAggFunc, formatDataFunc){
      return function (config){
        return function(rawData) {
          var formattedData = formatDataFunc ? formatDataFunc(rawData) : rawData;
          return ShopperReports.userDetails(
              formattedData,
              _.pick(config, ['dataParams', 'summaryParams']),
              summaryAggFunc
          );
        };
      }
    }

    function fetchAllTimeData(api, storeKeys, filters, metricField) {
      return function () {
        return StandardReports.getConsumerData(
            api,
            filters.pathParams.detailLevel,
            _.merge(filters.queryParams, {storeKey: storeKeys})
        ).then(function (data) {
              return StandardReports.transformIntoChartData(metricField)(data);
            });
      }
    }
  }

})();
